import { Form, Input } from "antd";
import { ReactNode, useEffect } from "react";

type Props = {
  employeeId?: number | string | null;
  employeeName?: string | null;
  designation?: string | null;
  department?: string | null;
  planType?: string | null;
  planPeriod?: string | null;
  dueDate?: string | null;
  unit?: string | null;
  lineManageName?: string | null;
  lineManageId?: number | null;
  lineManageDesignation?: string | null;
};

export default function KPIDetails(props: Props) {
  const [form] = Form.useForm();

  useEffect(() => {
    const defaultedValues = {
      employeeId: props.employeeId || "n/a",
      employeeName: props.employeeName || "n/a",
      designation: props.designation || "n/a",
      department: props.department || "n/a",
      planType: props.planType || "n/a",
      planPeriod: props.planPeriod || "n/a",
      dueDate: props.dueDate || "n/a",
      unit: props.unit || "n/a",
      lineManageName: props.lineManageName || "n/a",
      lineManageId: props.lineManageId || "n/a",
      lineManageDesignation: props.lineManageDesignation || "n/a",
    };

    form.setFieldsValue(defaultedValues);
  }, [form, props]);

  return (
    <div>
      <div className="self-stretch px-3 py-1.5 bg-slate-100 rounded-md inline-flex justify-start items-center gap-2.5 w-full">
        <div className="flex justify-start items-center gap-2.5">
          <div className="justify-start text-slate-600 text-lg font-semibold">
            KPI Details
          </div>
        </div>
      </div>

      <Form
        className="custom-form hide_star_mark"
        requiredMark="optional"
        layout="vertical"
        size="large"
        form={form}
      >
        <FormItem className="md:!grid-cols-4" title="">
          <Form.Item name="employeeId" label="Employee ID">
            <Input className="w-full" size="large" placeholder="-" disabled />
          </Form.Item>

          <Form.Item name="employeeName" label="Employee Name">
            <Input className="w-full" size="large" placeholder="-" disabled />
          </Form.Item>

          <Form.Item name="designation" label="Designation">
            <Input className="w-full" size="large" disabled placeholder="-" />
          </Form.Item>

          <Form.Item name="department" label="Department">
            <Input className="w-full" size="large" disabled placeholder="-" />
          </Form.Item>

          <Form.Item name="planType" label="Plan Type">
            <Input className="w-full" size="large" disabled placeholder="-" />
          </Form.Item>

          <Form.Item name="planPeriod" label="Plan Period">
            <Input className="w-full" size="large" disabled placeholder="-" />
          </Form.Item>

          <Form.Item name="dueDate" label="Due Date">
            <Input className="w-full" size="large" disabled placeholder="-" />
          </Form.Item>

          <Form.Item name="unit" label="Unit">
            <Input className="w-full" size="large" disabled placeholder="#" />
          </Form.Item>

          <Form.Item name="lineManageName" label="Line Manager Name">
            <Input className="w-full" size="large" disabled placeholder="-" />
          </Form.Item>

          <Form.Item name="lineManageId" label="Line Manager ID">
            <Input className="w-full" size="large" disabled placeholder="-" />
          </Form.Item>

          <Form.Item
            name="lineManageDesignation"
            label="Line Manager Designation"
          >
            <Input className="w-full" size="large" disabled placeholder="-" />
          </Form.Item>
        </FormItem>
      </Form>
    </div>
  );
}

type FormItemType = {
  title: string;
  rootClassName?: string;
  className?: string;
  children: ReactNode;
};

export const FormItem = ({
  title,
  rootClassName = "",
  className = "",
  children,
}: FormItemType) => (
  <div className={`mb-2 ${rootClassName}`}>
    <h5 className="text-header text-lg font-semibold leading-7 mb-4">
      {title}
    </h5>
    <div className={`grid md:grid-cols-3 sm:grid-cols-2 gap-x-4 ${className}`}>
      {children}
    </div>
  </div>
);
